import React from "react";
import { Link } from "react-router-dom";

const BreadcrumbItem = ({ to, children, isActive }) => {
  return (
    <li className={`breadcrumb-item ${isActive ? "active" : ""}`}>
      {to ? (
        <Link className={isActive === children ? "active" : undefined} to={to}>
          {children}
        </Link>
      ) : (
        <a
          href="#"
          className={isActive === children && "active"}
          onClick={(e) => e.preventDefault()}
        >
          <span aria-current="page">{children}</span>
        </a>
      )}
    </li>
  );
};

export default BreadcrumbItem;
